import { ScaleLinear, drag, select } from "d3";
import { clamp } from "lodash";
import React, { useEffect, useRef } from "react";

import { DragGroupElement } from "../../../../types";
import styles from "./playhead.module.scss";

const PLAYHEAD_DRAGGER_SIZE = 12;

export interface PlayheadProps {
  x: number;
  xOffset?: number;
  parentHeight: number;
  scale: ScaleLinear<number, number>;
  setTime: (time: number) => void;
}
export const Playhead = ({ x, xOffset = 0, parentHeight, scale, setTime }: PlayheadProps) => {
  const playheadRef = useRef<SVGGElement>(null);

  useEffect(() => {
    const g = playheadRef.current;

    const range = scale.range();

    if (g) {
      select<SVGGElement, null>(g).call(
        drag<SVGGElement, null>().on("drag", function (event: DragGroupElement) {
          const { x } = event;
          // clamp the x position to the timeline range
          const xPos = x - xOffset;
          const xPosClamped = clamp(xPos, range[0] || 0, range[1] || 0);
          // set the time based on the x position
          setTime(scale.invert(xPosClamped));
        })
      );
    }

    return () => {
      if (g) {
        select<SVGGElement, null>(g).on("mousedown.drag", null);
      }
    };
  }, [xOffset, scale, setTime]);

  return (
    <g ref={playheadRef} transform={`translate(${x}, 0)`}>
      <line className={styles.playheadLine} x1={0} y1={0} x2={0} y2={parentHeight} />
      <path
        className={styles.playheadDragger}
        d={`M -${PLAYHEAD_DRAGGER_SIZE / 2} 0 L ${PLAYHEAD_DRAGGER_SIZE / 2} 0 L ${
          PLAYHEAD_DRAGGER_SIZE / 2
        } ${PLAYHEAD_DRAGGER_SIZE} L 0 ${PLAYHEAD_DRAGGER_SIZE * 1.5} L -${
          PLAYHEAD_DRAGGER_SIZE / 2
        } ${PLAYHEAD_DRAGGER_SIZE} Z`}
      />
    </g>
  );
};
